import { LockKeyhole } from "lucide-react";

export default function BoardLocked({
  area,
  memberCount,
  threshold = 30,
}: {
  area: "Rounds" | "Messages";
  memberCount?: number;
  threshold?: number;
}) {
  return (
    <section className="pb-board-locked" aria-labelledby="board-locked-heading">
      <LockKeyhole size={22} aria-hidden="true" />
      <p className="pb-board-eyebrow">
        {area === "Rounds" && memberCount !== undefined
          ? `${memberCount} of ${threshold} members`
          : "Opens at 30 members"}
      </p>
      <h1 id="board-locked-heading">{area}</h1>
      <p>
        {area === "Rounds"
          ? "You’ll get an email when Rounds opens."
          : "Messages will provide private clinician-to-clinician conversations inside PulseBoard."}
      </p>
    </section>
  );
}
